// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__tcVi1","calendarButtons":"ClockData_calendarButtons__3a-en"};